<template>
  <div class="head-container">
    <div class="title-container">
      <h2>定位走势</h2>
      <b-form-group>
        <b-form-radio-group
          v-model="queryPageSize"
          :options="pageSizeList"
          buttons
          button-variant="outline-primary"
          size="sm"
          name="radios-btn-query" />
      </b-form-group>
    </div>
    <div class="option-container">
      <div
        class="col-options"
        :class="isMobile && colOptions.length > 5 ? 'form-wrap' : ''">
        <h3>选择名次</h3>
        <b-form-group>
          <b-form-radio-group
            v-model="selected"
            :options="colOptions"
            buttons
            inline
            button-variant="outline-primary"
            :size="isMobile || colOptions.length > 5 ? 'sm' : 'md'" />
        </b-form-group>
      </div>
      <div class="filter-options">
        <h3>标注选择</h3>
        <div>
          <b-form-checkbox
            size="sm"
            v-model="lStatus"
            name="leaks-status">
            遗漏
          </b-form-checkbox>
          <b-form-checkbox
            size="sm"
            v-model="llStatus"
            name="leaks-level-status">
            遗漏分层
          </b-form-checkbox>
          <b-form-checkbox
            size="sm"
            v-model="slStatus"
            name="show-line-status">
            折线图
          </b-form-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { allLots } from '@/constants/lots'
import { getLotTabById } from '@/utils/lot'
import { isMobile } from '@/utils/device'

export default {
  props: {
    selCol: {
      type: String,
      required: true
    },
    leaksStatus: {
      type: Boolean,
      required: true
    },
    leaksLevelStatus: {
      type: Boolean,
      required: true
    },
    showLineStatus: {
      type: Boolean,
      required: true
    },
    pageSize: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      pageSizeList: [
        { text: '最近50期', value: 50 },
        { text: '最近100期', value: 100 }
      ]
    }
  },
  computed: {
    lotId: {
      get () {
        if (!this.$route.query.id) {
          return allLots[0].children[0].id
        }
        return this.$route.query.id
      }
    },
    selected: {
      get () {
        return this.selCol
      },
      set (str) {
        this.$emit('handleSelChanged', str)
      }
    },
    queryPageSize: {
      get () {
        return this.pageSize
      },
      set (num) {
        this.$emit('handleChangePageSize', num)
      }
    },
    colOptions: {
      get () {
        return (
          getLotTabById(this.lotId).children
            .filter(lot => {
              return lot.id === this.lotId
            })[0]
            .rule.chart.headArr
            .map((item, idx) => {
              return {
                text: item,
                value: `col-${idx}`
              }
            })
        )
      }
    },
    lStatus: {
      get () {
        return this.leaksStatus
      },
      set (boo) {
        this.$emit('handleLeaksStatus', boo)
      }
    },
    llStatus: {
      get () {
        return this.leaksLevelStatus
      },
      set (boo) {
        this.$emit('handleLeaksLevelStatus', boo)
      }
    },
    slStatus: {
      get () {
        return this.showLineStatus
      },
      set (boo) {
        this.$emit('handleShowLineStatus', boo)
      }
    },
    isMobile () {
      return isMobile()
    }
  }
}
</script>
<style lang="scss" scoped>
.head-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-top: 20px;
  .title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .form-group {
      margin: 0 20px 0 0;
    }
    h2 {
      height: 50px;
      line-height: 50px;
      font-size: 20px;
      padding-left: 20px;
    }
  }
  .option-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    border-top: 1px solid #dee2e6;
    padding: 30px 30px 20px;
    // gap: 10px;
    font-size: 14px;
    .col-options {
      display: flex;
      justify-content: center;
      align-items: center;
      // gap: 15px;
      margin-bottom: 25px;
      & > h3 {margin-right: 20px;}
      & .form-group {margin-bottom: 0;}
    }
    .filter-options {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      // gap: 15px;
      & > h3 {margin-right: 20px;}
      & > div {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        & > div {margin-right: 20px;}
      }
    }
  }
}
@media (max-width: 575.98px) {
  .head-container {
    background-color: #FFF;
    padding-top: 5px;
    margin-bottom: 10px;
    .title-container {
      padding: 0 15px;
      .form-group {
        margin: 5px 0 0;
      }
      h2 {
        height: fit-content;
        line-height: 23px;
        font-size: 14px;
        font-weight: 400;
        padding: 20px 0 10px;
      }
    }
    .option-container {
      padding: 15px 15px 5px;
      // gap: 10px;
      font-size: 14px;
      .col-options {
        align-items: flex-start;
        flex-direction: column;
        // gap: 15px;
        margin-bottom: 20px;
        & > h3 {
          line-height: 23px;
          margin-right: 20px;
          margin-bottom: 10px;
          font-weight: 400;
        }
        & .form-group {margin-bottom: 0;}
      }
      .filter-options {
        justify-content: flex-start;
        flex-wrap: wrap;
        // gap: 15px;
        & > h3 {
          line-height: 23px;
          margin-bottom: 10px;
          font-weight: 400;
        }
        & > div {margin-bottom: 10px;}
      }
    }
  }
}
@media (min-width: 576px) and (max-width: 767.98px) {
  .head-container {
    background-color: #FFF;
    padding-top: 5px;
    margin-bottom: 10px;
    .title-container {
      padding: 0 15px;
      .form-group {
        margin: 5px 0 0;
      }
      h2 {
        height: fit-content;
        line-height: 23px;
        font-size: 14px;
        font-weight: 400;
        padding: 20px 0 10px;
      }
    }
    .option-container {
      padding: 15px 15px 5px;
      // gap: 10px;
      font-size: 14px;
      .col-options {
        align-items: flex-start;
        flex-direction: column;
        // gap: 15px;
        margin-bottom: 20px;
        & > h3 {
          line-height: 23px;
          margin-right: 20px;
          margin-bottom: 10px;
          font-weight: 400;
        }
        & .form-group {margin-bottom: 0;}
      }
      .filter-options {
        justify-content: flex-start;
        flex-wrap: wrap;
        // gap: 15px;
        & > h3 {
          line-height: 23px;
          margin-bottom: 10px;
          font-weight: 400;
        }
        & > div {margin-bottom: 10px;}
      }
    }
  }
}
@media (min-width: 768px) and (max-width: 991.98px) {
  .head-container {
    .option-container {
      .col-options {
        flex-wrap: wrap;
        justify-content: flex-start;
      }
    }
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {}
@media (min-width: 1200px) {}
</style>
<style lang="scss">
.form-wrap {
  margin-bottom: 10px!important;
  & div[role=group] {
    & .btn-group {
      flex-wrap: wrap;
      & .btn {
        margin-bottom: 10px;
      }
    }
  } 
}
</style>
